// src/pages/gt3x/RegisterList.jsx
import { useEffect, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";

const RANGE = "Anmeldungen!A1:K200";

export default function RegisterList() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                setLoading(true);
                setError("");

                const { rows: raw } = await fetchSheetViaProxy({ range: RANGE });

                // 🔍 Schlüssel dynamisch erkennen (insbesondere Zeitstempel)
                const sample = raw[0] || {};
                const keys = Object.keys(sample);

                const tsKey =
                    keys.find((k) =>
                        k.toLowerCase().includes("zeitstempel")
                    ) ||
                    keys.find((k) =>
                        k.toLowerCase().includes("timestamp")
                    ) ||
                    "Zeitstempel"; // Fallback

                // Rohdaten → saubere Struktur
                const cleaned = raw.map((r, idx) => {
                    const fullName = (r["Vor- und Nachname"] || "").trim();
                    const teamRaw  = (r["Teamname"] || "").trim();

                    // alle Zellwerte dieser Zeile als Großbuchstaben
                    const upperValues = Object.values(r || {}).map((v) =>
                        String(v ?? "").toUpperCase()
                    );

                    // Zeile ist Wartelisten-Trenner, wenn kein Name,
                    // aber irgendwo in der Zeile "WARTELISTE" steht
                    const isWaitlistSep =
                        !fullName && upperValues.some((val) => val.includes("WARTELISTE"));

                    return {
                        id:        r["ID"] || String(idx + 1),
                        ts:        r[tsKey] || "",
                        fullName,
                        discord:   r["Discord Name"] || "",
                        iracingId: r["iRacing ID"] || "",
                        team:      teamRaw,
                        numPro:    r["Startnummer PRO"] || "",
                        numAm:     r["Startnummer AM"] || "",
                        car:       r["Fahrzeug"] || "",
                        klasse:    r["Klasse"] || "",
                        fee:       r["Startgeld"] || "",
                        isWaitlistSep, // <- wichtig
                    };
                });

                // ✅ Fahrer mit Namen ODER Wartelisten-Trenner behalten
                const onlyWithName = cleaned.filter(
                    (r) =>
                        r.isWaitlistSep ||
                        (r.fullName && r.fullName.trim() !== "")
                );

                if (!cancelled) {
                    setRows(onlyWithName);
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) {
                    setError(
                        err instanceof Error ? err.message : "Unbekannter Fehler beim Laden."
                    );
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return (
            <div className="card card--accent">
                <h1>Anmeldeliste – GT3 Xperience</h1>
                <p>Die Anmeldungen werden geladen…</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="card card--accent">
                <h1>Anmeldeliste – GT3 Xperience</h1>
                <p>Fehler beim Laden der Anmeldungen:</p>
                <p style={{ color: "#ff6b6b" }}>{error}</p>
            </div>
        );
    }

    return (
        <div className="card card--accent">
            <h1>Anmeldeliste – GT3 Xperience</h1>
            <p style={{ marginBottom: "20px" }}>
                Hier siehst du die aktuell angemeldeten Fahrer der GT3 Xperience. <br/>
                Der Fahrername wird zeitnah grün eingefärbt sobald die Startgebühr entrichtet wurde.
            </p>
            <div className="fancyTable regTable-wrapper">
                <table className="tbl regTable">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Zeitstempel</th>
                        <th className="align-left">Vor- und Nachname</th>
                        <th className="align-left">Discord Name</th>
                        <th>iRacing ID</th>
                        <th className="align-left">Teamname</th>
                        <th># PRO</th>
                        <th># AM</th>
                        <th className="align-left">Fahrzeug</th>
                        <th>Klasse</th>
                        <th>Startgeld</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows.map((r) => {
                        // Sonderfall: Wartelisten-Trenner
                        if (r.isWaitlistSep) {
                            return (
                                <tr
                                    key={`waitlist-sep-${r.id || r.ts || "x"}`}
                                    className="reg-waitlist-sep"
                                >
                                    <td colSpan={11}>
                                        {r.team || "WARTELISTE"}
                                    </td>
                                </tr>
                            );
                        }

                        const klasseClass =
                            r.klasse === "PRO"
                                ? "klasse-pro"
                                : r.klasse === "AM"
                                    ? "klasse-am"
                                    : "";

                        const hasPaid = String(r.fee).toUpperCase() === "TRUE";

                        return (
                            <tr key={`${r.id}-${r.iracingId}-${r.fullName}`}>
                                <td>{r.id}</td>
                                <td>{r.ts}</td>
                                <td
                                    className="align-left"
                                    style={
                                        hasPaid
                                            ? { color: "#69fb90", fontWeight: 600 }
                                            : undefined
                                    }
                                >
                                    {r.fullName}
                                </td>
                                <td className="align-left">{r.discord}</td>
                                <td>{r.iracingId}</td>
                                <td className="align-left">{r.team}</td>
                                <td>{r.numPro}</td>
                                <td>{r.numAm}</td>
                                <td className="align-left">{r.car}</td>
                                <td className={klasseClass}>{r.klasse}</td>
                                <td>{hasPaid ? "✅" : ""}</td>
                            </tr>
                        );
                    })}
                    </tbody>


                </table>
            </div>
        </div>
    );
}
